import { FC } from 'react'
import { PageHeading } from '../../../../../../components/Header/PageHeading'
import { CriarRascunhoButton } from '../../../acoes/CriarRascunhoButton'
import { useProtocoloAcoes } from '../../../core/useProtocoloAcoes'
import { useEmpresaDaTela } from '../../../core/useEmpresaDaTela'
import { ModeloPublicado } from '../../../core/_models'

type Props = {
  modelo: ModeloPublicado
}

/**
 * Cabeçalho da tela, acima do card: versão do modelo como título, o que ele é como apoio e a
 * ação de criar rascunho na empresa (o modelo só é usado a partir de um rascunho).
 */
export const ModeloPublicadoHeading: FC<Props> = ({ modelo }) => {
  const { idEmpresa } = useEmpresaDaTela()
  const { acoes } = useProtocoloAcoes(idEmpresa)

  return (
    <PageHeading
      title={`Modelo Lauduz — versão ${modelo.versao}`}
      description='Sugestão inicial da Lauduz. Para usar, crie um rascunho na sua empresa.'
      actions={
        <CriarRascunhoButton
          escopo='modelo'
          idEmpresa={idEmpresa}
          versaoModelo={modelo.versao}
          podeCriarRascunho={acoes.podeCriarRascunho}
          rotulo='Criar rascunho a partir do modelo'
          aparencia='principal'
        />
      }
    />
  )
}
